import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ThemeService } from "@shared/services/theme/theme.service";
import { DomainService } from "@shared/services/domain/domain.service";
import { ExcuelaCarouselComponent } from "@shared/components/excuela-carousel/excuela-carousel.component";

@Component({
  selector: "app-presentation",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./presentation.component.html",
  styleUrls: ["./presentation.component.scss"],
  imports: [CommonModule, ExcuelaCarouselComponent],
})
export class PresentationComponent implements OnInit {

  readonly themeService: ThemeService = inject(ThemeService);
  readonly domainService: DomainService = inject(DomainService);

  ngOnInit(): void {
  }
}
